import {
  ContentfulCollection,
  ContentfulGenericPage,
  ContentfulNavDividerAndHeading,
  ContentfulNav,
  ContentfulNavMenu,
} from '@jbhi-fi/apis/src/contentful/types';
import { FooterNavigationProps } from '../FooterNavigation';
import { SocialsProps } from '../Socials/Socials';
import { PaymentOptionsProps } from '../PaymentOptions/PaymentOptions';
import { LegalsProps } from '../Legals/Legals';
import { NavItem } from '../types';

const parseContentfulNavMenu = (item: ContentfulNavMenu): NavItem => {
  const { url = '', heading = '', icon } = item.fields;

  return {
    url: url,
    label: heading,
    icon: icon?.fields.name,
    ariaLabel: heading,
  };
};

const filterFooterNavigationOnly = (
  item: ContentfulNavMenu | ContentfulNavDividerAndHeading | ContentfulCollection | ContentfulGenericPage
): boolean => 'url' in item.fields;

export const toFooterNavProps = ({ fields }: ContentfulNav): FooterNavigationProps => {
  const navOptions: FooterNavigationProps['navOptions'] = fields.navMenuItems.map(item => {
    const { heading, navMenuItems = [] } = item.fields;
    const filteredNavMenuItems = navMenuItems.filter(filterFooterNavigationOnly) as Array<ContentfulNavMenu>;

    return {
      label: heading,
      options: filteredNavMenuItems.map(parseContentfulNavMenu),
    };
  });

  return {
    navOptions,
  };
};

export const toSocialsProps = ({ fields }: ContentfulNav): SocialsProps => {
  const socialsLinks: SocialsProps['socialsLinks'] = fields.navMenuItems.map(item => {
    const { heading, url, logo } = item.fields;

    return {
      url: url,
      label: heading,
      icon: logo?.fields.file.url,
      ariaLabel: heading,
    } as NavItem;
  });

  return {
    socialsLinks,
  };
};

export const toPaymentProvidersProps = ({ fields }: ContentfulNav): PaymentOptionsProps => {
  const paymentOptions: PaymentOptionsProps['paymentOptions'] = fields.navMenuItems.map(item => {
    const { heading, logo } = item.fields;

    return {
      label: heading,
      icon: logo?.fields.file.url,
      ariaLabel: heading,
    };
  });

  return {
    paymentOptions,
  };
};

export const toFooterLegalsProps = ({ fields }: ContentfulNav): LegalsProps => {
  const legalsLinks: LegalsProps['legalsLinks'] = fields.navMenuItems.map(item => {
    const { heading, url } = item.fields;

    return {
      url: url,
      label: heading,
      ariaLabel: heading,
    } as NavItem;
  });

  return {
    legalsLinks,
  };
};
